<template>
    <div v-if="show" class="fixed inset-0 z-20 flex flex-col items-center w-full h-screen px-4 overflow-y-auto">
        <div class="absolute z-10 w-full h-full bg-gray-800 opacity-75" @click="close"></div>

        <div class="relative z-20 w-full max-w-xl my-auto">
            <div class="relative w-full p-4 bg-white rounded shadow-lg md:py-8 md:px-12">
                <button
                    v-if="canClose"
                    @click="close"
                    class="absolute top-0 right-0 flex items-center justify-center w-6 h-6 -mt-3 -mr-3 text-white rounded-full shadow-lg bg-brand-green"
                    type="button"
                >
                    <i class="fa fa-times"></i>
                </button>

                <component :is="modal"></component>
            </div>

            <component :is="card"></component>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                show: false
            }
        },

        mounted() {
            this.$event.$on('close-modal', this.close);
            this.$event.$on('open-modal', this.open);
        },

        computed: {
            ...mapGetters([
                'canClose',
                'card',
                'modal',
                'isUnactionable',
            ])
        },

        methods: {
            close() {
                if ( ! this.canClose && ! this.isUnactionable) {
                    return;
                }

                this.show = false;
            },

            open() {
                this.show = true;
            }
        },

        watch: {
            show (val) {
                if (val) {
                    document.body.classList.add('modal-open');
                    return;
                }

                document.body.classList.remove('modal-open');
            }
        }
    }
</script>
